export const textSize = {
  '2xs': 'text-2xs',
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  md: 'text-md',
  lg: 'text-xl',
  xl: 'text-3xl',
  '2xl': 'text-4xl',
};

export const iconSize = {
  xs: 'text-xs',
  sm: 'text-md ',
  base: 'text-lg',
  md: 'text-2xl', // TODO: deprecate
  lg: 'text-3xl',
  xl: 'text-3xl', // TODO: deprecate
};

export const textAlign = {
  left: 'text-left w-full',
  right: 'text-right w-full',
  center: 'text-center w-full',
  none: '',
};

export const textWrap = {
  nowrap: 'whitespace-nowrap',
};

export const textColor = {
  primary: 'text-off-white',
  secondary: 'text-black',
  tertiary: 'text-burple',
  quartiary: 'text-slatt',
  gray: 'text-some-gray',
  tag: 'text-tag-text',
  'dark-gray': 'text-dark-gray',
  'light-gray': 'text-light-gray',
  inherit: 'text-inherit',
};

export const iconColor = {
  primary: 'text-off-white',
  secondary: 'text-black',
  tertiary: 'text-burple',
  quartiary: 'text-slatt',
  gray: 'text-some-gray',
  tag: 'text-tag-text',
  'dark-gray': 'text-dark-gray',
  'light-gray': 'text-light-gray',
  inherit: 'text-inherit',
  redish: 'text-redish',
  orangish: 'text-orangish',
  greenish: 'text-greenish',
  blueish: 'text-blueish',
};

export const headingSize = {
  xs: 'text-sm',
  sm: 'text-md',
  base: 'text-xl',
  lg: 'text-2xl',
};

export const textStyle = {
  navigation: 'capitalize font-medium',
  tag: 'font-light uppercase',
  primary: '',
  'heading-1': 'font-bold',
  'heading-2': 'uppercase ',
  'heading-3': 'font-medium',
  supplementary: 'font-light',
  ellipsis: 'whitespace-nowrap overflow-hidden text-ellipsis w-full ',
};

export const headingStyle = {
  'heading-1': 'font-bold',
  'heading-2': 'uppercase font-medium',
  'card-title': 'font-medium',
};
